import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    $("select.select2", this.element).select2({
      dropdownParent: this.element,
    });
  }

  disconnect() {
    $("select.select2", this.element).select2("destroy");
  }
}
